@if (currentCase()) {
<app-cases-unboxing
  [caseItem]="currentCase()?.reward!"
  [config]="unboxingConfig()"
  [initialOpenCase]="initialOpen()"
></app-cases-unboxing>
} @else {
<svg-icon
  class="absolute-center flex items-center justify-center s-14"
  src="assets/icons/ui/loading.svg"
  [svgStyle]="{ width: '50px', height: '50px' }"
  svgClass="loading-animation"
></svg-icon>
}
